import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { conversationsApi } from '@/services/conversationsApi'
import type { ConversionEventInput } from '@/services/conversationsApi'
import { queryKeys } from '../keys'

export function useConversionEventsQuery(conversationId: string, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.conversations.conversionEvents(conversationId),
    queryFn: () => conversationsApi.getConversionEvents(conversationId),
    enabled,
  })
}

export function useSendConversionEvent(conversationId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (event: ConversionEventInput) => conversationsApi.sendConversionEvent(conversationId, event),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: queryKeys.conversations.conversionEvents(conversationId) }),
  })
}

export function useContactProfileQuery(conversationId: string, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.conversations.contactProfile(conversationId),
    queryFn: () => conversationsApi.getContactProfile(conversationId),
    enabled,
  })
}
